import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "truncate",
    standalone: false,
})
export class TruncatePipe implements PipeTransform {
    transform(
        value: string,
        limit: number = 100,
        trail: string = "..."
    ): string {
        if (!value) return "";
        if (value.length > limit) {
            return value.substring(0, limit) + trail;
        }
        return value;
    }
}
